import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'antd';
import {
  ModalSuccessIcon,
  ModalFailedIcon,
  ModalFinishIcon,
  ModalWarningIcon,
  ModalErrorIcon,
} from '../Icons';

import './CallbackModal.style.less';

const statusIcons = {
  success: <ModalFinishIcon width={32} height={32} />,
  failed: <ModalErrorIcon width={32} height={32} />,
  pending: <ModalWarningIcon width={32} height={32} />,
};

class CallbackModal extends Component {
  _renderSeriesResult = () =>
    this.props.seriesResult.map(result => {
      const statusIcon = statusIcons[result.status];
      return (
        <div className="series-results">
          <div className="row-result">
            {result.message} {statusIcon}
          </div>

          {result.info && (
            <div className={`row-info ${result.status}`}>{result.info}</div>
          )}
        </div>
      );
    });

  _renderSingleResult = () => {
    const { type, description } = this.props;
    const isSuccess = type === 'success';
    return (
      <div>
        {isSuccess ? <ModalSuccessIcon /> : <ModalFailedIcon />}
        <div
          className="title"
          style={{ color: isSuccess ? '#108ee9' : '#fa5454' }}
        >
          {isSuccess ? 'BERHASIL' : 'GAGAL'}
        </div>
        <div className="description">{description}</div>
      </div>
    );
  };

  render() {
    const { onClose, modalVisible, btnText, seriesResult } = this.props;
    return (
      <Modal
        footer={false}
        closable={false}
        centered
        visible={modalVisible}
        width={seriesResult ? 395 : 320}
        onCancel={onClose}
      >
        <div className="modal-wrapper">
          {seriesResult
            ? this._renderSeriesResult()
            : this._renderSingleResult()}
          <div className="button">
            <Button type="primary" block onClick={onClose}>
              <span className="btn-text">{btnText || 'OK'}</span>
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

CallbackModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  modalVisible: PropTypes.bool.isRequired,
  type: PropTypes.oneOf(['success', 'failed']),
  description: PropTypes.any,
  btnText: PropTypes.string,
  seriesResult: PropTypes.array,
};

export default CallbackModal;
